var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { filter } from 'rxjs/operators';
var TextBox = /** @class */ (function (_super) {
    __extends(TextBox, _super);
    function TextBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null,
            invalid: false,
            help: null
        };
        return _this;
    }
    TextBox.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            invalid: false,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            invalid: true,
            help: Object.keys(error.constraints)
                .map(function (key) { return React.createElement(React.Fragment, null,
                React.createElement("span", null, error.constraints[key]),
                React.createElement("br", null)); })
        }); });
    };
    TextBox.prototype.setValue = function (value) {
        this.setState({
            value: value
        });
        this.props.dataState.set(this.props.control.path, value, {
            sender: this
        });
    };
    TextBox.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    TextBox.prototype.render = function () {
        var _this = this;
        return React.createElement(TextField, { label: this.props.control.label, margin: "dense", variant: "outlined", fullWidth: true, placeholder: this.props.control.placeholder, helperText: this.state.help, error: this.state.invalid, InputLabelProps: {
                shrink: true,
            }, value: this.state.value || '', onChange: function (event) { return _this.setValue(event.target.value); } });
    };
    return TextBox;
}(React.Component));
export default TextBox;
//# sourceMappingURL=TextBox.js.map